import axiosInstance from "api/axiosInstance";

import type { Category, CategoryCreateRequest } from "api/types/category.types";
import type { PaginatedResponse } from "api/types/product.types";

const BASE = "/server/buccl_main/api/v1/categories/";
const ADMIN_BASE = "/server/buccl_main/api/v1/admin/categories/";

export const categoriesService = {
  list: (params?: { page?: number; parent?: number | null; depth?: number; is_active?: boolean }) => axiosInstance.get<PaginatedResponse<Category>>(BASE, { params }),

  listAll: () => axiosInstance.get<PaginatedResponse<Category> | Category[]>(BASE),

  get: (id: number) => axiosInstance.get<Category>(`${BASE}${id}/`),

  create: (payload: CategoryCreateRequest) => axiosInstance.post<{ message: string; category: Category }>(ADMIN_BASE, payload),

  update: (id: number, payload: Partial<CategoryCreateRequest>) => axiosInstance.patch<Category>(`${ADMIN_BASE}${id}/`, payload),

  remove: (id: number) => axiosInstance.delete(`${ADMIN_BASE}${id}/`),
};
